/**
 * IST time helpers for display.
 *
 * DB timestamps are stored as UTC ISO strings. This module converts them to
 * Asia/Kolkata for display. It does NOT touch inputs or payloads sent to the
 * backend — those stay UTC ISO.
 */

const IST_TZ = "Asia/Kolkata";

// Display formatters cached once.
const fmtDateTime = new Intl.DateTimeFormat("en-IN", {
  timeZone: IST_TZ,
  year: "numeric", month: "2-digit", day: "2-digit",
  hour: "2-digit", minute: "2-digit", hourCycle: "h23",
});
const fmtDateOnly = new Intl.DateTimeFormat("en-IN", {
  timeZone: IST_TZ,
  year: "numeric", month: "2-digit", day: "2-digit",
});
const fmtTimeOnly = new Intl.DateTimeFormat("en-IN", {
  timeZone: IST_TZ,
  hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23",
});

function parseOrNull(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** "YYYY-MM-DD HH:MM" in IST, e.g. "2026-04-30 18:05" */
export function fmtIST(iso) {
  const d = parseOrNull(iso);
  if (!d) return "";
  // en-IN with 2-digit options renders "30/04/2026, 18:05"; we reshape for our tables.
  const parts = Object.fromEntries(fmtDateTime.formatToParts(d).map((p) => [p.type, p.value]));
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`;
}

/** "YYYY-MM-DD" in IST */
export function fmtISTDate(iso) {
  const d = parseOrNull(iso);
  if (!d) return "";
  const parts = Object.fromEntries(fmtDateOnly.formatToParts(d).map((p) => [p.type, p.value]));
  return `${parts.year}-${parts.month}-${parts.day}`;
}

/** "HH:MM:SS" in IST */
export function fmtISTTime(iso) {
  const d = parseOrNull(iso);
  if (!d) return "";
  return fmtTimeOnly.format(d).replace(/\./g, ":");
}

/** "YYYY-MM-DD HH:MM IST" — same as fmtIST but with suffix for crowded screens. */
export function fmtISTTagged(iso) {
  const s = fmtIST(iso);
  return s ? `${s} IST` : "";
}

/** Today's date (IST) as "YYYY-MM-DD" — drop-in for the old `new Date().toISOString().slice(0,10)`. */
export function todayIST() {
  return fmtISTDate(new Date());
}
